// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"690124fe","787":"7efd31bd"}[chunkId] + ".chunk.js";
};